<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="targetTitle" width="750px" >
    <div slot="content">
      <el-form :model="formData" ref="formData" :rules="rules">
        <el-row>
          <h4>기본정보</h4>
        </el-row>
        <el-row class="rule-setting-title" type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item label="룰 아이디" prop="ruleId">
              <el-input :disabled="popupMode === 'update'" placeholder="룰 아이디를 입력해주세요" v-model="formData.ruleId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="룰 이름" prop="ruleName">
              <el-input placeholder="룰 이름을 입력해주세요" v-model="formData.ruleName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item label="룰 등급" prop="severityId">
              <el-select style="width: 100%;" v-model="formData.severityId">
                <el-option v-for="item in severityList" :key="item.severityId" :label="item.severityName" :value="item.severityId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="벤더" prop="vendorId">
              <el-select v-model="formData.vendorId" style="width: 100%;">
                <el-option v-for="item in vendorList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="개요" prop="ruleDescr">
          <el-input placeholder="개요를 입력해주세요" v-model="formData.ruleDescr" type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="판단기준" prop="ruleStandard">
          <el-input placeholder="판단기준을 입력해주세요" v-model="formData.ruleStandard" type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-row v-if="initFlag" v-for="(ruleCheckScriptData, index) in ruleCheckScript" :key="index" type="flex" :gutter="4">
          <el-col :span="6"><el-select v-model="ruleCheckScriptData.expressions"
            @change="onInputChange(ruleCheckScriptData, ruleCheckScriptData.expressions)">
            <el-option label="AND" value="and"></el-option>
            <el-option label="OR" value="or"></el-option>
          </el-select></el-col>
          <el-col :span="6"><el-select v-model="ruleCheckScriptData.inclusions"
            @change="onInputChange(ruleCheckScriptData, ruleCheckScriptData.inclusions)">
            <el-option label="포함" value="inclusion"></el-option>
            <el-option label="미포함" value="exclusion"></el-option>
          </el-select></el-col>
          <el-col :span="12"><el-input v-model="ruleCheckScriptData.script" placeholder="값을 입력해주세요."
            @change="onInputChange(ruleCheckScriptData, ruleCheckScriptData.script)"></el-input></el-col>
          <el-col style="width: 34px;">
          <el-button v-if="((ruleCheckScript.length - 1) === index)" size="small" type="plain" @click="addRuleCheckScript()">
            <i class="fas fa-plus" />
          </el-button>
          <el-button v-else size="small" type="plain" @click="deleteRuleCheckScript(index)">
            <i class="fas fa-minus" />
          </el-button>
          </el-col>
        </el-row>
        <el-form-item class="rule-setting-title" label="조치방법" prop="standardAction">
          <el-input placeholder="조치방법을 입력해주세요" v-model="formData.standardAction" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-row class="rule-setting-title">
          <h4>권장 스크립트</h4>
        </el-row>
        <el-row>
          <el-form-item label="스크립트 선택" prop="templateId">
            <w-select-form search=true modifiable="true" v-model="formData.templateId" :target="formData" @change="onChangeScriptTemplate" :option-list="templateList" option-key="templateId" property="templateId" labelprop="templateName">
            </w-select-form>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="스크립트 설명" prop="templateDescr">
            <el-input disabled type="textarea" v-model="formData.templateDescr" :rows="5"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="스크립트" prop="templateScript">
            <el-input disabled type="textarea" v-model="formData.templateScript" :rows="5"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid"  @click="onClickSaveButton">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { cloneDeep, isUndefined } from 'lodash';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import NetdeviceSecurityPolicySettingsAPI from '@/api/settings/netdevice/netdevice-security-policy-settings';

export default {
  name: 'WAddRuleSettingSlidingPopup',
  components: {
    WSelectForm,
  },
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
    vendorList: {
      type: Array,
      defaut: () => {},
    },
  },
  data() {
    return {
      rules: {
        ruleId: { required: true, trigger: 'blur', validator: this.checkRuleId },
        ruleName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
      targetTitle: '',
      popupMode: 'add',
      initFlag: true,
      formData: {
        vendorId: 0,
        objCompanyId: '',
        templateId: '',
        severityId: '',
        ruleName: '',
        ruleId: '',
        ruleDescr: '',
        ruleStandard: '',
        standardAction: '',
      },
      ruleCheckScript: [],
      severityList: [],
      templateList: [],
    };
  },
  mounted() {
    NetdeviceSecurityPolicySettingsAPI.getRuleSeverity().then((res) => {
      if (res.data.success) {
        this.severityList = res.data.data;
      }
    });
    NetdeviceSecurityPolicySettingsAPI.getTemplateList().then((res) => {
      if (res.data.success) {
        this.templateList = res.data.data;
      }
    });
  },
  methods: {
    open(item) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
        this.ruleCheckScript = [];
        this.initRuleCheckScript();
        this.formData.vendorId = this.targetData.objCompanyId;
        if (item) {
          this.popupMode = 'update';
          this.formData = cloneDeep(item);
          this.formData.vendorId = this.targetData.objCompanyId;
          this.targetTitle = `${this.targetData.objCompanyName} 보안정책 룰 수정`;
          this.ruleCheckScript = JSON.parse(item.ruleCheckScript);
          // 템플릿이 있는 경우만 값 세팅
          if (item.templateId) {
            this.formData.templateId = item.templateId;
            this.onChangeScriptTemplate(item.templateId);
          } else {
            this.$set(this.formData, 'templateId', '');
          }
        } else {
          this.popupMode = 'add';
          this.formData.severityId = this.severityList[0].severityId;
          this.targetTitle = `${this.targetData.objCompanyName} 보안정책 룰 추가`;
          this.addRuleCheckScript();
        }
      });
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    onInputChange(ruleCheckScript, value) {
      if (value !== '') delete ruleCheckScript.blankFlag;
      else ruleCheckScript.blankFlag = true;
    },
    addRuleCheckScript() {
      this.ruleCheckScript.push({
        expressions: 'and',
        inclusions: 'inclusion',
        script: '',
        blankFlag: true,
      });
      this.initRuleCheckScript();
    },
    deleteRuleCheckScript(index) {
      this.ruleCheckScript.splice(index, 1);
      this.initRuleCheckScript();
    },
    // component refresh
    initRuleCheckScript() {
      this.initFlag = false;
      this.$nextTick(() => {
        this.initFlag = true;
      });
    },
    onChangeScriptTemplate(value) {
      const targetList = this.templateList.find((item) => item.templateId === value);
      this.formData.templateId = value;
      this.$set(this.formData, 'templateScript', targetList.script);
      this.$set(this.formData, 'templateDescr', targetList.templateDescr);
    },
    onClickSaveButton() {
      this.$refs.formData.validate().then((valiResponse) => {
        if (valiResponse) {
          // 값을 입력하지 않은 필드는 포함하지않는다.
          const ruleCheckScript = this.ruleCheckScript.filter((value) => (!value.blankFlag));
          if (ruleCheckScript.length === 0) {
            this.$message(msgUtil.getCustomMsgData('하나 이상의 기준을 입력해주세요'));
          } else {
            this.formData.ruleCheckScript = JSON.stringify(ruleCheckScript);
            this.formData.viewType = this.popupMode;
            const action = this.popupMode === 'add' ? msgUtil.action.ADD : msgUtil.action.SAVE;
            const target = '룰';
            NetdeviceSecurityPolicySettingsAPI.setNetdevicePolicyRule(this.formData).then((res) => {
              if (res.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                this.clickCloseBtn();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      }).catch(() => {});
    },
    // rule 중복 체크 검사
    checkRuleId(rule, value, callback) {
      if (isUndefined(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (this.popupMode === 'update') {
        callback();
      } else {
        NetdeviceSecurityPolicySettingsAPI.checkRuleId({ vendorId: this.formData.vendorId, ruleId: value }).then((res) => {
          if (res.data.data) {
            callback(new Error('이미 사용 중인 룰 ID입니다.'));
          } else {
            callback();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.rule-setting-title {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/RuleViolationSettings/RuleSettings/popup/AddRuleSettingSlidingPopup.vue